import React from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Flex from 'typescript-styled-flex'
import { Checkbox, Form, FormGroup } from '../../../components/FormBuilder'
import { PrepaidType } from '../../../models/Object'
import mapObjectToFormSettings from '../../../models/Object/mappers/mapObjectToFormSettings'
import { getUpdateReservationFormEvent } from '../../../reducers/bookingCalendar/selectors/events'
import { getUserSettings } from '../../../reducers/userObject/selectors/settings'
import useSize from '../../../hooks/useSize'
import reduxForm from './withReduxForm'

const ModalReservation = ({ prepaidType }: IModalReservationProps) => {
  const { t } = useTranslation()
  const size = useSize()

  return (
    <Form onSubmit={null}>
      <Flex
        column={true}
        style={{ overflow: 'hidden', padding: `0px ${16 * size}px` }}
      >
        <FormGroup.Render
          size={size}
          column={true}
          title={t('menu_reservations')}
        >
          <Flex
            column={true}
            style={{
              paddingLeft: `${10 * size}px`,
              paddingTop: `${10 * size}px`,
            }}
          >
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.reservationTime'}
              label={t('reservation_hours')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isReverse={true}
              isHorizontal={true}
              noSpacing={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.daysCount'}
              label={t('z677_number_of_nights')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              noSpacing={true}
              isHorizontal={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.setCustomColor'}
              label={t('custom_booking_color')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              noSpacing={true}
              isHorizontal={true}
              isReverse={true}
            />

            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.pricePerPerson'}
              label={t('z677_price_per_person')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              noSpacing={true}
              isHorizontal={true}
              isReverse={true}
            />

            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.pricePerDay'}
              label={t('reservation_price_per_day')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              noSpacing={true}
              isHorizontal={true}
              isReverse={true}
            />

            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.advancePaymentDate'}
              label={
                Number(prepaidType) === PrepaidType.Advance
                  ? t('pre_payment_form_advance_menu')
                  : t('pre_payment_form_down_menu')
              }
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              noSpacing={true}
              isHorizontal={true}
              isReverse={true}
            />

            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.onSitePaymentDate'}
              label={t('reservation_pay_on_place_menu')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.timeToPayDays'}
              label={t('z677_waiting_for_payment')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.advancePaymentType'}
              label={`${t('payment_type')} - ${
                Number(prepaidType) === PrepaidType.Advance
                  ? t('reservation_advance_payment')
                  : t('pre_payment_form_down')
              }`}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.onSitePaymentType'}
              label={`${t('payment_type')} - ${t('reservation_pay_on_place')}`}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.onSitePayment'}
              label={t('reservation_pay_on_place')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />

            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.deposit'}
              label={t('reservation_deposit')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />

            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.localTax'}
              label={t('reservation_local_tax')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />

            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.advancePayment'}
              label={
                Number(prepaidType) === PrepaidType.Advance
                  ? t('reservation_advance_payment')
                  : t('pre_payment_form_down')
              }
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.additionalServices'}
              label={t('z2736_label_additional_services')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
          </Flex>
        </FormGroup.Render>
        <FormGroup.Render
          size={size}
          column={true}
          title={t('reservation_person')}
          style={{ paddingBottom: `${10 * size}px` }}
        >
          <Flex
            column={true}
            style={{
              paddingLeft: `${10 * size}px`,
              paddingTop: `${10 * size}px`,
            }}
          >
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.email'}
              label={t('email')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.additionalGuests'}
              label={t('z677_additional_guests')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.company'}
              label={t('reservation_company_name')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
          </Flex>
        </FormGroup.Render>
        <FormGroup.Render
          size={size}
          column={true}
          title={t('reservation_page_details')}
        >
          <Flex
            column={true}
            style={{
              paddingLeft: `${10 * size}px`,
              paddingTop: `${10 * size}px`,
            }}
          >
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.reservationSource'}
              label={t('reservation_source')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.residenceRegistration'}
              label={t('reservation_registration')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.feeding'}
              label={t('reservation_services')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.doorCode'}
              label={t('door_code')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.numberOfBeds'}
              label={t('number_of_beds')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
            <Checkbox.ReduxField
              size={size}
              fireEventOnClick={true}
              name={'fieldVisibility.creationDate'}
              label={t('z677_creation_date')}
              wrapperStyle={{ marginBottom: `${10 * size}px` }}
              isHorizontal={true}
              noSpacing={true}
              isReverse={true}
            />
          </Flex>
        </FormGroup.Render>
      </Flex>
    </Form>
  )
}

const mapStateToProps = state => {
  const settings = mapObjectToFormSettings(getUserSettings(state))
  const event = getUpdateReservationFormEvent(state)
  return {
    prepaidType: event ? event.prepaidType : settings.prepaidType,
  }
}

export default reduxForm(connect(mapStateToProps)(ModalReservation))

export interface IModalReservationProps {
  initialTab?: number
  prepaidType: PrepaidType
}
